import React, { useEffect } from 'react';
import { NumericInput, Classes, Dialog, Button, InputGroup, FormGroup, Intent, HTMLSelect } from "@blueprintjs/core";


const DialogAddCriteria = ({ criteria, dialogIsOpen, onCloseDialog, onChangeInput, onChangeNumericInput, onAddCriteria }) => {

    useEffect(() => {
        // if (criteria.type || criteria.type === "OPEN") {
        //     onChangeNumericInput('default', '')
        // }
        // eslint-disable-next-line 
    }, [criteria])

    return (
        <Dialog
            icon="add"
            title="Add criteria"
            autoFocus={true}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            usePortal={true}
            enforceFocus={true}
            isOpen={dialogIsOpen}
            onClose={onCloseDialog}>
            <div className={Classes.DIALOG_BODY}>
                <FormGroup label="Feedback type" labelFor="feedback-type">
                    <HTMLSelect
                        id="feedback-type"
                        fill={true}
                        name="type"
                        defaultValue={"UNK"}
                        onChange={onChangeInput}
                    >
                        <option disabled value="UNK">
                            Choose type
                        </option>
                        <option value="OPEN">Open</option>
                        <option value="CLOSE">Closed</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup
                    label="Criteria name / Question asked"
                    labelFor="criteria-name">
                    <InputGroup
                        id="criteria-name"
                        name="name"
                        disabled={!criteria.type}
                        onChange={onChangeInput} />
                </FormGroup>
                <FormGroup
                    label="Minimum value"
                    labelFor="criteria-min">
                    <NumericInput
                        id="criteria-min"
                        name="min"
                        value={criteria.min}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onValueChange={(value) => onChangeNumericInput('min', value)} />
                </FormGroup>
                <FormGroup
                    label="Minimum value caption"
                    labelFor="criteria-min">
                    <InputGroup
                        id="criteria-min"
                        placeholder='Not required'
                        name="minCaption"
                        value={criteria.minCaption ? criteria.minCaption : ''}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onChange={onChangeInput} />
                </FormGroup>
                <FormGroup
                    label="Maximal value"
                    labelFor="criteria-max">
                    <NumericInput
                        // id="criteria-max"
                        name="max"
                        value={criteria.max}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onValueChange={(value) => onChangeNumericInput('max', value)} />
                </FormGroup>
                <FormGroup
                    label="Maximal value caption"
                    labelFor="criteria-min">
                    <InputGroup
                        // id="criteria-min"
                        placeholder='Not required'
                        name="maxCaption"
                        value={criteria.maxCaption ? criteria.maxCaption : ''}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onChange={onChangeInput} />
                </FormGroup>
                <FormGroup
                    label="Default value"
                    labelFor="criteria-default">
                    <NumericInput
                        id="criteria-default"
                        name="default"
                        value={criteria.default}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onValueChange={(value) => onChangeNumericInput('default', value)} />
                </FormGroup>
                <FormGroup
                    label="Step"
                    labelFor="criteria-step">
                    <NumericInput
                        id="criteria-step"
                        name="step"
                        value={criteria.step}
                        disabled={!criteria.type || criteria.type === "OPEN"}
                        fill={true}
                        onValueChange={(value) => onChangeNumericInput('step', value)} />
                </FormGroup>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        onClick={onCloseDialog}
                        text="Cancel" />
                    <Button
                        onClick={onAddCriteria}
                        text="Add"
                        disabled={criteria.name == null || criteria.name.length === 0}
                        intent={Intent.SUCCESS}
                        rightIcon="add" />
                </div>
            </div>
        </Dialog>
    );
}


export default DialogAddCriteria;
